import { render, staticRenderFns } from "./tonguedetail.vue?vue&type=template&id=07d3f5ed&scoped=true&"
import script from "./tonguedetail.vue?vue&type=script&lang=js&"
export * from "./tonguedetail.vue?vue&type=script&lang=js&"
import style0 from "./tonguedetail.vue?vue&type=style&index=0&id=07d3f5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3f5ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d3f5ed')) {
      api.createRecord('07d3f5ed', component.options)
    } else {
      api.reload('07d3f5ed', component.options)
    }
    module.hot.accept("./tonguedetail.vue?vue&type=template&id=07d3f5ed&scoped=true&", function () {
      api.rerender('07d3f5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/tonguedetail.vue"
export default component.exports